import styled from 'styled-components'

function returnNumericSize(size) {
  switch (size) {
    case 'xs':
      return 16
    case 'sm':
      return 24
    case 'md':
      return 34
    case 'lg':
      return 48
    case 'xg':
      return 64
    default:
      return 34
  }
}

export default styled.div`
  @keyframes animate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  width: ${(props) => returnNumericSize(props.size)}px;
  height: ${(props) => returnNumericSize(props.size)}px;
  border-radius: 50%;
  border: 3px solid rgba(247, 247, 250, 0.6);
  border-top-color: ${(props) => (props.inverse ? '#ffffff' : '#a6a6a6')};
  animation: animate 0.6s infinite linear;
`
